import { render, staticRenderFns } from "./InterfaceChoose.vue?vue&type=template&id=791b6db0"
import script from "./InterfaceChoose.vue?vue&type=script&lang=jsx"
export * from "./InterfaceChoose.vue?vue&type=script&lang=jsx"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports